import _taggedTemplateLiteral from "/Users/icloudsdevelopers/Projects/Web/nucleos_modules/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      overflow: hidden;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      overflow: hidden;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  @font-face {\n    font-family: 'GoogleSans-Regular';\n    font-style: normal;\n    font-weight: normal;\n    src: url('../assets/fonts/Regular/GoogleSans-Regular.ttf');\n    src: local('Google Sans'), local('GoogleSans'),\n      url('../assets/fonts/Regular/GoogleSans-Regular.eot?#iefix') format('embedded-opentype'),\n      url('../assets/fonts/Regular/GoogleSans-Regular.woff2') format('woff2'),\n      url('../assets/fonts/Regular/GoogleSans-Regular.woff') format('woff'),\n      url('../assets/fonts/Regular/GoogleSans-Regular.ttf') format('truetype'),\n      url('../assets/fonts/Regular/GoogleSans-Regular.svg#GoogleSans') format('svg');\n  }\n\n  @font-face {\n    font-family: 'GoogleSans-Medium';\n    font-weight: normal;\n    font-style: normal;\n    src: url('../assets/fonts/Medium/GoogleSans-Medium.ttf');\n    src: local('Google Sans'), local('GoogleSans'),\n      url('../assets/fonts/Medium/GoogleSans-Medium.eot?#iefix') format('embedded-opentype'),\n      url('../assets/fonts/Medium/GoogleSans-Medium.woff') format('woff'),\n      url('../assets/fonts/Medium/GoogleSans-Medium.ttf') format('truetype'),\n      url('../assets/fonts/Medium/GoogleSans-Medium.svg#GoogleSans') format('svg');\n  }\n\n  @font-face {\n    font-family: 'GoogleSans-Bold';\n    font-style: bold;\n    font-weight: 700;\n    src: url('../assets/fonts/Bold/GoogleSans-Bold.ttf');\n    src: local('Google Sans'), local('GoogleSans'),\n      url('../assets/fonts/Bold/GoogleSans-Bold.eot?#iefix') format('embedded-opentype'),\n      url('../assets/fonts/Bold/GoogleSans-Bold.woff') format('woff'),\n      url('../assets/fonts/Bold/GoogleSans-Bold.ttf') format('truetype'),\n      url('../assets/fonts/Bold/GoogleSans-Bold.svg#GoogleSans') format('svg');\n  }\n\n  * {\n    margin: 0;\n    padding: 0;\n    outline: 0;\n    box-sizing: border-box;\n    scroll-behavior: smooth;\n\n    transition: .3s;\n  }\n\n  *:focus {\n    outline: 0;\n  }\n\n  html {\n    min-height: calc(100vh - 56px);\n\n    ", "\n  }\n\n  body, #root {\n    min-height: calc(100vh - 56px);\n\n    ", "\n  }\n\n  body {\n    -webkit-font-smoothing: antialiased;\n\n    ", "\n  }\n\n  body, input, button {\n    font: 16px 'GoogleSans-Regular';\n  }\n\n  a {\n    color: ", ";\n    text-decoration: none;\n  }\n\n  ul {\n    list-style: none;\n  }\n\n  button {\n    cursor: pointer;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { createGlobalStyle } from 'styled-components';
import media from 'styled-media-query';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import colors from './colors';
export default createGlobalStyle(_templateObject(), media.lessThan('large')(_templateObject2()), media.lessThan('large')(_templateObject3()), media.lessThan('large')(_templateObject4(), function (props) {
  return props.primary;
}), colors.black);